import { cookie } from '@pdrj/pmi-iqos-shared-react'

export default class IqosphereAuth {
  constructor(api) {
    this.api = api
  }

  getPosition = async (sync = false, fetchNotices = false, logout = false) => {
    const res = await this.api.get(
      '/iqosphere/position' +
        (sync ? '?sync=true' : '') +
        (logout ? '?logout=true' : ''),
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        data: {
          notices: fetchNotices
        },
        useProxy: true,
        withCredentials: true,
        mock: this.api.getMock('position')
      }
    )
    return res
  }
}
